import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import { IBreadcrumbsLink } from "../../../state";

import styles from "./TeacherHeader.module.scss";

export type Props = {
  links: IBreadcrumbsLink[];
};

const TeacherHeader: React.FC<Props> = ({ links, children }) => {
  return (
    <div className={styles.wrapper}>
      <div>
        {links.map((link, index) => (
          <Link
            className={clsx(link.to === "#" && styles.active)}
            to={{ pathname: link.to, state: link.state, search: link.search }}
            key={index}
          >
            {link.name}
          </Link>
        ))}
      </div>
      <div className="d-flex">{children}</div>
    </div>
  );
};

export default TeacherHeader;
